import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import useGetProfile from './useGetProfile';

const ENDPOINT = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://property-tax-api.yourwayhome.com';

interface Payload {
  id: string;
  _id?: string;
  accountId?: string;
  emailAddress?: string;
  emailAddress2?: string;
  firstName?: string;
  lastName?: string;
  coOwnerFirstName?: string;
  coOwnerLastName?: string;
  addressLine1?: string;
  addressLine2?: string;
  phoneNumber?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  inviteSent?: string;
}

export default function useUpdateClient() {
  const queryClient = useQueryClient();
  const navigation = useNavigate();

  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      navigation('/dashboard');

      const { id, ...rest } = payload;

      const response = await fetch(`${ENDPOINT}/api/v1/clients/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(rest),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['CLIENTS'] });
    },
  });
}
